// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import App from "./App";
import Login from "./Login";
import Loggedout from "./Loggedout";
import ForgotPassword from "./ForgotPassword";
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: `${process.env.REACT_APP_AUTHORITY}`,
  client_id: `${process.env.REACT_APP_LOGIN_CLIENT_ID}`,
  redirect_uri: `${process.env.REACT_APP_LOGIN_REDIRECT_URI}`,
  response_type: `${process.env.REACT_APP_LOGIN_RESPONSE_TYPE}`,
  silent_redirect_uri: `${process.env.REACT_APP_LOGIN_REDIRECT_URI}`,
  scope: "email openid profile",
  onSigninCallback: () =>
    window.history.replaceState({}, document.title, window.location.pathname),
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <AuthProvider {...cognitoAuthConfig}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/loggedout" element={<Loggedout />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </AuthProvider>
  </BrowserRouter>,
);
